import { render } from "./CurList.vue?vue&type=template&id=d88967ae&scoped=true"
import script from "./CurList.vue?vue&type=script&lang=js"
export * from "./CurList.vue?vue&type=script&lang=js"

import "./CurList.vue?vue&type=style&index=0&id=d88967ae&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d88967ae"]])

export default __exports__